import { createRouter, createWebHistory } from "vue-router"

import PropertiesView from "../views/PropertiesView.vue"

const routes = [
	{
		path: "/",
		component: PropertiesView
	}, {
		path: "/folder",
		component: () => import("../views/PropertiesFolder.vue"),
	}, {
		path: "/file/open",
		component: () => import("../views/DocOpen.vue"),
	}, {
		path: "/file/import",
		component: () => import("../views/DocImport.vue"),
	}, {
		path: "/track/edit/:uuid?/:tab?",
		component: () => import("../views/TrackEdit.vue"),
	}, {
		path: "/track/:type?",
		component: () => import("../views/TrackView.vue"),
	}, {
		path: "/write",
		component: () => import("../views/WriteView.vue"),
	}, {
		path: "/section/:uuid",
		component: () => import("../views/SectionEdit.vue"),
	}, {
		path: "/section/:section/scene/:scene/:tab?",
		component: () => import("../views/SceneEdit.vue"),
	}, {
		path: "/conflict",
		component: () => import("../views/DocConflict.vue"),
	}, {
		path: "/outdated",
		component: () => import("../views/DocOutdated.vue"),
	}, {
		path: "/settings",
		component: () => import("../views/SettingsMain.vue"),
	}, {
		path: "/settings/webdav/:uuid?",
		component: () => import("../views/SettingsWebDAV.vue"),
	}
]

const router = createRouter({
	history: createWebHistory(process.env.BASE_URL),
	routes,
	scrollBehavior(to, from, savedPosition) {
		if (to.hash) {
			return {
				el: to.hash,
				top: 60,
			}
		}
	},
})

export default router
